import { ErrorMessage } from '@common/components'
import React, { FunctionComponent, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
// Import the page views
const Buy = lazy(() => import('@buy/App'))

export type ParamTypes = {
    [key: string]: string | undefined
    pathProduct: string
    plan: string
}

const BuyProductRoutes: FunctionComponent = () => {
    return (
        <Routes>
            {/* billing main page with customize */}
            <Route path=":pathProduct/*" element={<Buy />} />

            {/* fallback */}
            <Route
                path="/*"
                element={
                    <div style={{ padding: 20, margin: 20 }}>
                        {/* TODO: Find out if we should show an error, redirect to some default page or redirect to the 404 page on goto.com */}
                        <ErrorMessage errorMessage="Uh-oh! The page you are looking for was not found." />
                    </div>
                }
            />
        </Routes>
    )
}

export default BuyProductRoutes
